import { Banner, Button } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'

/**
 * Creates a mock Button for Banner
 */
function createBannerButton(overrides: Partial<Button> = {}): Button {
  return {
    _uid: '5f13f8ff-9af1-43c0-967f-5cbe81ec9e88',
    link: createStoryblokMultilink({
      linktype: 'story',
    }),
    size: 'medium',
    label: 'Button label',
    style: 'default',
    component: 'button',
    button_color: 'primary',
    _editable:
      '<!--#storyblok#{"name": "button", "space": "228071", "uid": "5f13f8ff-9af1-43c0-967f-5cbe81ec9e88", "id": "300939517"}-->',
    ...overrides,
  }
}

/**
 * Creates a mock Banner
 * @param overrides - Partial fields to override defaults
 * @returns Complete Banner mock
 */
export function createBanner(overrides: Partial<Banner> = {}): Banner {
  return {
    _uid: '3266c231-d661-4e70-8f23-7070127cfd6b',
    buttons: [createBannerButton()],
    headline: 'Banner Headline',
    component: 'banner',
    full_width: false,
    text_color: 'dark',
    subheadline:
      'Ex eiusmod ut esse nostrud occaecat dolore consequat Lorem tempor.',
    background_blur: {
      value: 0,
      plugin: 'storyblok-slider',
    },
    pattern_overlay: false,
    background_image: createStoryblokAsset({
      id: 8908003,
      filename:
        'https://a.storyblok.com/f/228071/1920x1080/a17bd8776b/development.jpeg',
      src: 'https://a.storyblok.com/f/228071/1920x1080/a17bd8776b/development.jpeg',
      width: 1920,
      height: 1080,
      aspect_ratio: 1.78,
      content_type: 'image/jpeg',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    background_brightness: {
      value: 0,
      plugin: 'storyblok-slider',
    },
    _editable:
      '<!--#storyblok#{"name": "banner", "space": "228071", "uid": "3266c231-d661-4e70-8f23-7070127cfd6b", "id": "300939517"}-->',
    ...overrides,
  }
}
